<template>
  <div
    id="ranges"
    class="row"
  >
    <div class="col-12">
      <vuetify-table
          :type="type"
          :headers="headers"
          :api-u-r-l="apiURL"
          :title="title"
          :query-params="queryParams"
          permisosNuevoRegistro="crear_serie_empresa"
          permisosEditar="editar_serie_empresa"
          permisosEliminar="eliminar_serie_empresa"
        >
      </vuetify-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  components: {
    VuetifyTable,
  },
  props: {
    id: { default: '' },
    enterpriseId: { default: '' },
  },
  data: () => ({
    currentTitle: '',
    queryParams: '',
    type: '',
    dialog: false,
    toggleStatus: false,
    headers: [
      {
        text: 'Nombre',
        value: 'name',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'active',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
      },
    ],
    name: '',
    isNumeration: true,
  }),
  computed: {
    apiURL() {
      return `/api/enterprises/${this.enterpriseId}/N-A/series_dealer_serie`;
    },
    title() {
      return 'Series';
    },
    ...mapGetters({
      user: 'auth/user',
      themeColor: 'theme/themeColor',
    }),
  },
  mounted() {
    if (!this.can('cambiar_estado_serie_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Estado'), 1);
    }
    if (!this.can('editar_serie_empresa') && !this.can('eliminar_serie_empresa')) {
      this.headers.splice(this.headers.findIndex(({ text }) => text === 'Acciones'), 1);
    }
  },
  methods: {
  },
};
</script>
